import { cn } from "@/lib/utils";

type VolkswagenLogoProps = {
  className?: string;
  fill?: string;
};

export default function VolkswagenLogo({
  className,
  fill = "currentColor",
}: VolkswagenLogoProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31"
      fill="none"
      className={cn(className)}
    >
      <path
        d="M15.1221 28.8488C7.60449 28.8488 1.43399 22.6397 1.43399 15.1221C1.43399 13.4322 1.72851 11.8292 2.29825 10.3276L10.3035 26.4395C10.4097 26.6519 10.5352 26.8209 10.7911 26.8209C11.047 26.8209 11.1822 26.6471 11.2788 26.4395L14.9531 18.1832C14.9965 18.1011 15.0352 18.0142 15.1221 18.0142C15.209 18.0142 15.2476 18.1011 15.2911 18.1832L18.9654 26.4395C19.0571 26.6471 19.1971 26.8209 19.453 26.8209C19.7041 26.8209 19.8344 26.6519 19.9407 26.4395L27.9459 10.3276C28.5156 11.8292 28.8102 13.4322 28.8102 15.1221C28.8102 22.6397 22.6445 28.8488 15.1269 28.8488H15.1221ZM15.1221 12.0175C15.0352 12.0175 14.9965 11.9306 14.9531 11.8485L10.6463 2.17754C12.0417 1.67057 13.5626 1.39536 15.1221 1.39536C16.6864 1.39536 18.2073 1.67057 19.5979 2.17754L15.2911 11.8485C15.2476 11.9354 15.209 12.0175 15.1221 12.0175ZM10.7477 21.9444C10.6656 21.9444 10.6221 21.8575 10.5787 21.7754L3.61153 7.73003C4.85722 5.8277 6.52779 4.22472 8.53152 3.10456L13.5384 14.2578C13.6205 14.4703 13.7509 14.5089 13.9198 14.5089H16.3291C16.4981 14.5089 16.6237 14.4654 16.7106 14.2578L21.7175 3.10456C23.726 4.22472 25.3918 5.8277 26.6375 7.73003L19.6703 21.7754C19.6268 21.8575 19.5834 21.9444 19.5013 21.9444C19.4144 21.9444 19.3758 21.8575 19.3323 21.7754L16.7154 15.7787C16.6285 15.5663 16.503 15.5228 16.334 15.5228H13.9247C13.7557 15.5228 13.6301 15.5663 13.5432 15.7787L10.9263 21.7754C10.8829 21.8575 10.8442 21.9444 10.7573 21.9444H10.7477ZM15.1221 30.2442C23.4846 30.2442 30.2442 23.4846 30.2442 15.1221C30.2442 6.75955 23.4846 0 15.1221 0C6.75955 0 0 6.75955 0 15.1221C0 23.4846 6.75955 30.2442 15.1221 30.2442Z"
        fill={fill}
      />
    </svg>
  );
}
